import css from "./clubCard.module.css";
import { Dialog, IconArrowBigRight, IconLink, LogoClub, Text } from "@idg-web-platform/pulse";
import colors from "../../styles/colors.module.css";
import { ClubMembershipState } from "../../club/clubPage.tsx";
import { useEffect, useRef, useState } from "preact/hooks";
import classNames from "classnames";

interface ClubCardProps {
  active: boolean;
  hasAnyCode: boolean;
  firstName: string;
  lastName: string;
  appCode?: string;
  cardCode?: string;
  appCodeImage?: string;
  cardCodeImage?: string;
  state: ClubMembershipState;
}

export function ClubCard({
  active,
  hasAnyCode,
  firstName,
  lastName,
  appCode,
  cardCode,
  appCodeImage,
  cardCodeImage,
  state,
}: ClubCardProps) {
  const dialogRef = useRef<HTMLDialogElement>(null);
  const [isAppCodeDialogOpen, setIsAppCodeDialogOpen] = useState(false);

  const handleClose = () => {
    setIsAppCodeDialogOpen(false);
  };

  const handleOpenAppCode = () => {
    console.log("Open card code dialog: ", isAppCodeDialogOpen);
    setIsAppCodeDialogOpen(true);
  };

  useEffect(() => {
    if (isAppCodeDialogOpen) {
      dialogRef.current?.showModal?.();
    } else {
      dialogRef.current?.close?.();
    }
  }, [isAppCodeDialogOpen]);

  useEffect(() => {
    dialogRef.current?.addEventListener("close", handleClose);
    return () => {
      dialogRef.current?.removeEventListener("close", handleClose);
    };
  }, []);
  return (
    <>
      {active && hasAnyCode ? (
        <button
          type={"button"}
          onClick={handleOpenAppCode}
          className={classNames(css.clubCard, css.clubCardCodeButton)}
          data-dd-privacy="mask"
        >
          <div className={css.clubCardHeader}>
            <Text
              text={"Kundenkarte"}
              sizeStep={0}
              fontStyle="bold"
              removeMargin={true}
              class={css.clubCardName}
            />
          </div>
          <div className={css.clubCardContent}>
            <div className={css.clubCardLogoAndName}>
              <div className={css.clubCardLogo}>
                <LogoClub />
              </div>
              <Text
                text={`${firstName} ${lastName}`}
                sizeStep={0}
                fontStyle="prose"
                removeMargin={true}
                class={css.clubCardUserName}
              />
            </div>
            <div className={css.clubCardCodes}>
              {appCode && (
                <div className={css.clubCardCode}>
                  <img id="appCode" src={appCodeImage} alt="Dein CLUB QR Code" />
                </div>
              )}
            </div>
          </div>
          <div
            className={css.clubCardButton}
            class={css.clubCardLink}
            style={{ marginTop: "auto" }}
          >
            <IconLink
              text="Kundenkarte öffnen"
              href={""}
              iconComponent={<IconArrowBigRight />}
              iconPosition="right"
            />
          </div>
          <div style={{ display: "contents" }}>
            {isAppCodeDialogOpen && (
              <Dialog
                ref={dialogRef}
                role="dialog"
                class={css.clubCardDialog}
                onClose={handleClose}
              >
                <div className={css.appCodeContent}>
                  <div className={css.dialogLogo}>
                    <LogoClub class={css.clubLogo} />
                  </div>
                  <Text
                    text={`${firstName} ${lastName}`}
                    sizeStep={1}
                    fontStyle="prose"
                    removeMargin={true}
                    class={css.dialogUserName}
                  />
                  <img src={appCodeImage} className={css.dialogImg} alt="Dein CLUB QR Code" />
                  <Text
                    text={appCode}
                    sizeStep={0}
                    fontStyle="prose"
                    removeMargin={true}
                    class={css.dialogCodes}
                  />
                  <img src={cardCodeImage} className={css.dialogImg} alt="Dein CLUB Barcode" />
                  <Text
                    text={cardCode}
                    sizeStep={0}
                    fontStyle="prose"
                    removeMargin={true}
                    class={css.dialogCodes}
                  />
                </div>
              </Dialog>
            )}
          </div>
        </button>
      ) : (
        <div className={css.clubCard} data-dd-privacy="mask">
          <Text class={colors.darkBlueText} fontStyle={"bold"} sizeStep={0}>
            Status deiner CLUB-Karte
          </Text>

          <Text sizeStep={-1} removeMargin={true}>
            {state === ClubMembershipState.None && <>Keine Mitgliedschaft im CLUB</>}

            {(state === ClubMembershipState.ApprovalRequired ||
              state === ClubMembershipState.AlreadyLinked) && (
              <>
                Schön, dass du auch online bei INTERSPORT dabei bist. Beachte bitte, dass es aktuell
                nicht möglich ist, deine bereits vorhandene CLUB-Karte mit deinem
                Intersport.de-Kundenkonto zu verknüpfen. Solltest du etwas bestellt haben, melde
                dich bitte bei unserem <a href="/c/account/contact?issue=club">Kundenservice</a>,
                damit wir dir die Versandkosten und Punkte gutschreiben können. Wir arbeiten daran,
                versprochen.
              </>
            )}

            {state === ClubMembershipState.Active && (
              <>Du hast keine CLUB-Karte. Wende dich an unseren Kundenservice.</>
            )}

            {state === ClubMembershipState.Pending && <>In Bearbeitung</>}
          </Text>
        </div>
      )}
    </>
  );
}
